// @flow

import { SELECT_YOUTUBE_ACCOUNT } from 'actions';

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_YOUTUBE_ACCOUNT:
      return Object.assign({}, state, { selectedYoutubeAccount: action.id });
    default:
      return state;
  }
};

export default reducer;
